<template>
  <div class="components__generic-accordion">
    <!-- header - the clickable part -->
    <div class="accordion-header-container" v-on:click="toggle">
      <div>
        <slot name="header">HEADER</slot>
      </div>
      <div><slot name="chevron"><i class="accordion-chevron frontend-icon" v-bind:class="chevronClass"></i></slot></div>
    </div>
    <!-- content - the toggable content -->
    <slot v-if="showContent" name="content">CONTENT</slot>
  </div>
</template>

<style lang="scss" scoped>
.components__generic-accordion {
  .accordion-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .accordion-chevron {
      font-size: 20px;
    }
  }
}
</style>

<script lang="ts" setup>
  import { computed, ref, toRefs, watch } from 'vue';

  const props = defineProps({
    value: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["update:model-value"]);

  const { value } = toRefs(props);
  const internalState = ref<boolean>(false);

  const showContent = computed(() => {
      // we use xor here, so when one of the two variables flips,
      // the output flips
      return !!internalState.value;
    })
  const chevronClass = computed(() => showContent.value ? "fi-expand_less" : "fi-expand_more")
  
  const toggle = () => {
    emit("update:model-value", !internalState.value);
    internalState.value = !internalState.value;
  };

  watch(value, (newValue: boolean) => {
    internalState.value = newValue;
  }, 
  { immediate: true });
</script>
